module.exports = __webpack_public_path__ + "Play.png";